export const NavItems = [
	{ path: "/", label: "ABOUT" },
	{ path: "/books", label: "BOOKS" },
	{
		label: "RESEARCH",
		path: "/research/grants",
		submenu: [
			{ path: "/research/grants", label: "GRANTS" },
			{
				label: "PUBLICATIONS",
				path: "/research/publications/Articles",
				submenu: [
					{
						path: "/research/publications/Articles",
						label: "ARTICLES",
					},
					{
						path: "/research/publications/Chapters",
						label: "CHAPTERS",
					},
				],
			},
		],
	},
	{ path: "/teaching", label: "TEACHING" },
	{
		label: "PROFESSIONAL ENGAGEMENT",
		path: "/professionalEngagement/guestLectures",
		submenu: [
			{
				path: "/professionalEngagement/guestLectures",
				label: "GUEST LECTURES",
			},
			{ path: "/professionalEngagement/consulting", label: "CONSULTING" },
			{ path: "/professionalEngagement/workshop", label: "WORKSHOPS" },
			{
				path: "/professionalEngagement/services",
				label: "SERVICE TO THE PROFESSION",
			},
			{
				path: "/professionalEngagement/editorialBoards",
				label: "EDITORIAL BOARDS",
			},
		],
	},
	{ path: "/cv", label: "CV" },
	{ path: "/awards", label: "AWARDS" },
	{ path: "/contacts", label: "CONTACTS" },
];
